import React, { Fragment, useContext, useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "react-bootstrap";
import { ArrowDown, ArrowUp } from "react-feather";
import ModelChart from "../../../Screens/GlobalUser/AIModelReports/Components/Charts/ModelChart";
import AreaService from "../../../../api/areaService";
import Loader1 from "./../../../../CommonElements/Spinner/loader";
import Loader3 from "./../../../../CommonElements/Spinner/loader3";
import Index from "../../AreaDashbaord/reports/Index";
import AccuracyCard from "./AccuracyCard";
import { getCurrentWeekWithYear } from "../../../../utils/currentWeekWithYear";
import './../../AreaDashbaord/reports/Components/LiveAlertsCards/livealerts.css'
import DownloadContext from '../../../../_helper/formData/LiveAnalytics/LiveAnalytics'
import { moduleaccuracy, dataAlerts } from "./Static";
import FaceDetectionsQA from "../../../IF/pages/face-detections/FaceDetectionQA";


export default function YTMLQADash() {

  const [acceptedArray, setAcceptedArray] = useState([]);
  const [rejectedArray, setRejectedArray] = useState([]);
  const [togglee, settogglee] = useState(false)
  const [runApi, setRunApi] = useState(false);
  const [lastFilter, setLastFilter] = useState(null);
  const [loader, setLoader] = useState(true);
  const [series2, setSeries2] = useState({});
  const [factoryID, setfactoryID] = useState(JSON.parse(localStorage.getItem('userData')).factory.id || 0)
  const [accuracySectionData, setAccuracySectionData] = useState({
    aiAccuracy: undefined,
    connectivity: undefined,
    highSeverityAlerts: undefined,
    maxAlerts: undefined,
  });
  const getCurrentWeek = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();

    // Get the first day of the year
    const firstDayOfYear = new Date(year, 0, 1);
    const pastDaysOfYear = (currentDate - firstDayOfYear) / 86400000;

    // Calculate the current week number
    const currentWeekNumber = Math.ceil(
      (pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7
    );

    // Return the formatted value in YYYY-Wxx format
    return `${year}-W${currentWeekNumber.toString().padStart(2, "0")}`;
  };

  const { setTechQaContext, techQaContext } = useContext(DownloadContext)

  const currentWeekk = getCurrentWeekWithYear();
  const getCurrentWeekNumber = () => {
    const currentWeek = getCurrentWeekWithYear(); // This gives you something like "2024-W45"
    const weekNumber = currentWeek.split("W")[1]; // Extract the week number (e.g., "45")
    return weekNumber;
  };

  const currentWeekNumber = getCurrentWeekNumber();
  useEffect(() => {

    let fils = JSON.parse(localStorage.getItem('qafilters'))
    if (!fils) {
      localStorage.setItem('qafilters', JSON.stringify(qaFilters))
    }
    else {
      setQaFilters(fils)
    }

  }, [])


  async function modelAccuracy(payload) {
    // setLoader(true)
    const res = moduleaccuracy
    
    
    // await AreaService.getModelAccuracyChart(payload);
    // if (res) {
    //   setLoader(false);
    // }
    console.log("these are models");
    const formattedArray = Object?.entries(res)?.map(([name, values]) => ({
      name,
      result_true: values.result_true,
      ai_result_true: values.ai_result_true,
    }));
    setSeries2(formattedArray);

    // const modifiedData = res?.data?.totalAlertsChart.map((item) => {
    //   // Modify the names as required
    //   if (item.name === "forklift_person_in_same_aisle") {
    //     item.name = "MMHE";
    //   } else if (item.name === "emergency_exit_blockage") {
    //     item.name = "Emergency Exit";
    //   } else if (item.name === "machine_guard_open") {
    //     item.name = "Machine Guard";
    //   }

    //   return item;
    // });

    // Set the modified data in setSeries2
    const modifiedData = (res?.data || []).map((item, key) => {
      if (item.name === "forklift_person_in_same_aisle") {
        item.name = "MMHE";
      } else if (item.name === "emergency_exit_blockage") {
        item.name = "Emergency Exit";
      } else if (item.name === "machine_guard_open") {
        item.name = "Machine Guard";
      }
      return item;
    });


    setTechQaContext((prev) => ({
      ...prev,
      complianceData: modifiedData
    }))

    // Calculate the average value of the total alerts chart
    const nonZeroValues = modifiedData
      .map((item) => item.value)
      .filter((value) => value !== 0);
    const averageValue =
      nonZeroValues.reduce((acc, val) => acc + val, 0) / nonZeroValues.length

    // Update the aiAccuracy in the accuracySectionData state
    // setAccuracySectionData((prevState) => ({
    //   ...prevState,
    //   aiAccuracy: {
    //     ...prevState.aiAccuracy,
    //     value: Math.round(averageValue), // Set the average of values as aiAccuracy
    //   },
    // }));
  }

  const [allowButton, setAllowButton] = useState(false);
  const [qaFilters, setQaFilters] = useState({
    user_id: 1,
    identifier: "week",
    factory_id: factoryID,
    filters: {
      approval: "Select Approval",
      module: "",
      severity: "",
      shift: [],
      date: "",
      week: currentWeekk,
      month: "",
      starting: "",
      ending: "",
      area: '',
      subarea: "",
    },
    pagination: {
      page_no: 1,
      per_page: 21,
    },
  });


  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    const fils = JSON.parse(localStorage.getItem('qafilters'))
    const formatDate = (dateStr) => {
      const [year, month, day] = dateStr.split("-");
      return `${month}/${day}/${year}`;
    };
    // {
    //   week: currentWeekk,
    //   factory_id: factoryID
    // };

    const payload = {
      user_id: 1,
      identifier: "week",
      factory_id: factoryID,
      filters: qaFilters,
      pagination: {
        page_no: 1,
        per_page: 21,
      },
    };

    const updatedFilters = {
      ...fils,
      filters: {
        ...fils.filters,
        areas: fils.filters.area !== "" ? [fils.filters.area] : []  // Add areas inside the existing filters
      }
    };

    delete updatedFilters.filters.area;
    setLoader(true); // Start loader before API calls

    Promise.all([
      modelAccuracy(updatedFilters),
      fetchAlerts(fils)
    ]).then(([modelResponse, alertResponse]) => {
      // Both API responses are available here
      console.log('Model Accuracy Response:', modelResponse);
      console.log('Alerts Response:', alertResponse);
    }).catch((error) => {
      console.error('Error fetching data:', error);
    }).finally(() => {
      setLoader(false);  // Turn off loader after both calls complete
    });
    // modelAccuracy(qaFilters);
  }, [
    // togglee, 
    togglee]);

    const role = JSON.parse(localStorage.getItem('role'))


  async function fetchAlerts(payload) {
    // setLoader(true)
    const updated_payload={
        ...payload,
        role:JSON.parse(localStorage.getItem('role')),
      }
    const res = dataAlerts
    
    // await AreaService.getFilterAlerts(updated_payload)
    // if(res){
    //   setLoader(false)
    // }
    console.log('api ok')
    if(role=='qa'){

      setAccuracySectionData((prevState) => ({
        ...prevState,
        aiAccuracy: {
          ...prevState.aiAccuracy,
          value: Math.round((
            ((res.acceptedRecords / (res.acceptedRecords + res.rejectedRecords)) * 100)
          )), // Set the average of values as aiAccuracy
        },
      }));
    }
    else if(role=='aitechqa'){
        setAccuracySectionData((prevState) => ({
        ...prevState,
        aiAccuracy: {
          ...prevState.aiAccuracy,
          value: Math.round((
            ((res.acceptedRecords / (res.acceptedRecords + res.rejectedRecords)) * 100)
          )), // Set the average of values as aiAccuracy
        },
      }));
    }

    setTechQaContext((prev) => ({
      ...prev,
      aiAccuracy: Math.round((
        ((res.acceptedRecords / (res.acceptedRecords + res.rejectedRecords)) * 100)
      ))
    }))

  }



 


  return (
    <>
    {/**
      <Index
        togglee={togglee}
        settogglee={settogglee}
        acceptedArray={acceptedArray}
        rejectedArray={rejectedArray}
        setAcceptedArray={setAcceptedArray}
        setRejectedArray={setRejectedArray}
        runApi={runApi}
        setRunApi={setRunApi}
        allowButton={allowButton}
        setAllowButton={setAllowButton}
        setQaFilters={setQaFilters}
      />
    */}
    <FaceDetectionsQA/>
    </>
  );
}
